import React, { Component } from "react";
import Immutable from "immutable";
import Fade from "@material-ui/core/Fade";
// import Immutable from 'immutable';
import { withStyles } from "@material-ui/core/styles";
import RemainingTime from "components/UI/RemainingTime";
import Paragrapher from "components/UI/Paragrapher";
import Template from "components/Template/Template";
// import Box from '@material-ui/core/Box';
// import Typography from '@material-ui/core/Typography';
// import Button from '@material-ui/core/Button';
import { connect } from "react-redux";
import config from "config/api";
import clsx from "clsx";
// import Grid from '@material-ui/core/Grid';
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import Container from "@material-ui/core/Container";
// import withWidth from '@material-ui/core/withWidth';
import isArray from "mout/lang/isArray";
// import IconPlay from '@material-ui/icons/PlayCircleFilled';
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
// import AddIcon from '@material-ui/icons/Add';
// import EventIntro from 'components/Event/EventIntro';
import BlockTitle from "components/UI/BlockTitle";
import BlockRatio from "components/BlockRatio";
import Orchestrator from "components/UI/Orchestrator/Orchestrator";
import getRemainingTime from "helpers/getRemainingTime";
import gotoLiveRoom from "helpers/gotoLiveRoom";
// import BlockButton  from 'components/UI/BlockButton';
// import MyEventsContainer from 'components/Event/MyEventsContainer';
// import RemainingTime from 'components/UI/RemainingTime';
import Spinner from "components/UI/Spinner";
import Header from "../Header/Header";
import HeaderContent from "../Header/HeaderContent";
import HeaderSub from "../Header/HeaderSub";
import Footer from "../Footer";
import LiveHelp from "./LiveHelp";
import ScrollToTopOnMount from "components/UI/ScrollToTopOnMount";
// import Bubble from 'components/UI/Bubble';
// import HelpSpeedTest from 'components/Help/HelpSpeedTest';
// import PopinWrapper from 'components/PopinWrapper';
// import EventSubscription from 'components/Event/EventSubscription';
// import EventSubscriptionFor from 'components/Event/EventSubscriptionFor';
import EventCardSimple from "components/Event/EventCardSimple";
import LiveMessage from "components/Lives/LiveMessage";
// import DialogPopinButton from 'components/UI/Dialog/DialogPopinButton';
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { fetchLive, getLiveData, getLiveError } from "../../ducks/live";
import {
  fetchData,
  getDataHome,
  getLoadingError,
} from "../../ducks/asyncFetcher";
import {
  isLoggedIn,
  getCurrentUserRole,
  getCurrentUser,
} from "ducks/authentication";
import MuiAlert from "@material-ui/lab/Alert";
import i18n from "helpers/i18n";
import { primaryColor } from "helpers/colors";
const AF_KEY = "home";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const styles = (theme) => {
  // console.log(theme)
  return {
    root: {
      // maxWidth: "1280px",
      margin: "0 auto",
      minHeight: "600px",
      maxWidth: 1280,
    },
    fullWidth: {
      width: "100%",
    },
    headerBg: {
      // minHeight: 210,
      // backgroundImage: "url(" + require("assets/images/header.jpg") + ")",
      backgroundPosition: "0 0",
      [theme.breakpoints.down("sm")]: {
        backgroundImage: "none",
      },
    },
    mainWrapper: {
      fontSize: "14px",
    },
    mainTitle: {
      marginBottom: 40,
      textAlign: "center",
    },
    livePaper: {
      color: "#fff",
      maxWidth: 1280,
      margin: "0 auto",
      padding: "40px 20px 50px",
      [theme.breakpoints.down("sm")]: {
        margin: "0 20px",
      },
    },
    inline: {
      display: "inline-block",
    },
    header: {
      // height: 150,
      // [theme.breakpoints.down("sm")]: {
      //   height: 200
      // }
    },
    content: {
      // height: 'calc(100% - 150px - 120px)',
      // [theme.breakpoints.down("sm")]: {
      // height: 'auto'
      // }
    },
    regularHeight: {
      height: "auto",
    },
    footer: {
      width: "100%",
      // height: 120,
      // [theme.breakpoints.down("sm")]: {
      //   height: 'auto'
      // }
    },
    big: {
      fontSize: "20px",
    },
    instructions: {
      color: theme.palette.primary.main,
      marginBottom: 20,
    },
  };
};
class Lives extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logMessage: false,
    };
    this._gotoLiveRoom = this._gotoLiveRoom.bind(this);
    this._onMessageSent = this._onMessageSent.bind(this);
    this._handleSnackbarClose = this._handleSnackbarClose.bind(this);
    this._runRemainingTimer = this._runRemainingTimer.bind(this);
  }
  componentDidMount() {
    const liveId = this.props.match.params.id;
    this.props.onMount({
      liveId,
    });
    this._startTimer();
  }
  componentDidUpdate(oldProps) {
    if (oldProps.$$liveData !== this.props.$$liveData) {
      this._startTimer();
    }
  }
  componentWillUnmount() {
    this._stopTimer();
  }
  _stopTimer() {
    // console.log('timer stop')
    if (this._remainingTimer) {
      clearInterval(this._remainingTimer);
    }
  }
  _startTimer() {
    // console.log('timer start')
    // const $$card = this._getCard();
    // console.log('test1')
    if (this._remainingTimer) return;
    const $$liveEvent = this._getCard();
    // console.log('test2', $e)
    if ($$liveEvent === undefined) return;
    // console.log('starting timer')
    // this._cardTimer = $$card.get('eventDate');
    this._remainingTimer = setInterval(this._runRemainingTimer, 1000);
    this._runRemainingTimer();
  }
  _runRemainingTimer() {
    // console.log('run1')
    // const { $$card } = this.props;
    // const $$liveEvent = $$card;
    const $$liveEvent = this._getCard();
    // console.log('run2', $e)
    if ($$liveEvent === undefined) {
      return this._stopTimer();
    }
    // console.log('run3')
    // console.log($e)
    // console.log($e.get('eventState'))
    const timeRemaining =
      $$liveEvent !== undefined && $$liveEvent.get("eventState") != "live"
        ? getRemainingTime($$liveEvent.get("eventDate"))
        : {
            days: 0,
            hours: 0,
            minutes: 0,
          };
    // console.log(timeRemaining)
    if (
      timeRemaining.days <= 0 &&
      timeRemaining.hours <= 0 &&
      timeRemaining.minutes <= 0
    ) {
      this.setState(
        {
          showLiveButton: true,
        },
        () => {
          // console.log('STOPPPING')
          this._stopTimer();
        }
      );
    } else {
      // console.log('RUN')
      const { showLiveButton } = this.state;
      if (
        showLiveButton !== true &&
        timeRemaining.days <= 0 &&
        timeRemaining.hours <= 0 &&
        timeRemaining.minutes <= 15
      )
        this.setState({
          showLiveButton: true,
        });
      this.setState({
        timeRemaining,
      });
    }
  }
  _gotoLiveRoom(e) {
    // const { $$card } = this.props;
    const $$card = this._getFakeCard();
    if (e !== undefined && e.preventDefault !== undefined) e.preventDefault();
    gotoLiveRoom($$card, () => {
      this._goto("/live/" + $$card.get("id"));
    });
  }
  _getCard() {
    const { $$data, match, $$liveData } = this.props;
    const { id } = match.params;
    let found = undefined;
    // if ($$data !== undefined && $$data.get("live")) {
    //   found = $$data.get("live").filter((e) => e.get("id") === id);
    //   found = found.get(0) !== undefined ? found.get(0) : undefined;
    // }
    // if (
    //   found === undefined &&
    //   $$data !== undefined &&
    //   $$data.get("availableEvents")
    // ) {
    //   found = $$data.get("availableEvents").filter((e) => e.get("id") === id);
    //   found = found.get(0) !== undefined ? found.get(0) : undefined;
    // }
    if ($$liveData !== undefined) found = $$liveData.get("live");
    return found;
  }
  _getCardImage($$card) {
    let cardImage = false;
    // let cardPresentation = false;
    let decodedValues;
    if (
      $$card !== undefined &&
      $$card.get("eventThumb") !== undefined &&
      $$card.get("eventThumb") !== null &&
      $$card.get("eventThumb") !== false
    ) {
      try {
        decodedValues = JSON.parse($$card.get("eventThumb"));
      } catch (e) {}
      // console.log('decoded is', decodedValues)
      if (
        decodedValues !== undefined &&
        isArray(decodedValues) &&
        decodedValues[0] &&
        decodedValues[0].dest
      ) {
        cardImage =
          config.eventthumbpreview.replace("{eventId}", $$card.get("id")) +
          "/" +
          decodedValues[0].dest;
      }
    }
    return cardImage;
  }
  _getFakeCard() {
    const { match } = this.props;
    const { id } = match.params;
    if (id === "doipjiodezjdiozjdeiij") return true;
    else return this._getCard();
  }
  _onMessageSent() {
    this.setState({
      logMessage: "Question envoyée !",
    });
  }
  _handleSnackbarClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      logMessage: false,
    });
  }
  render() {
    const { $$data, userRole, onPanelToggle, classes, $$user } = this.props;
    const { logMessage, showLiveButton } = this.state;
    // const showLiveButton = true;
    const $$subscriptions =
      userRole !== undefined &&
      $$data !== undefined &&
      $$data !== undefined &&
      $$data.get("myfutureevents") !== undefined
        ? $$data.get("myfutureevents").map((e) => e.get("id"))
        : Immutable.Map();
    // const $$card = this._getCard();
    const $$card = this._getFakeCard();
    // if($$card !== undefined) console.log('card is', $$card.toJS())
    // else console.log('CARD IS NOT FOUND !')
    const timeRemaining =
      $$card !== undefined ? getRemainingTime($$card.get("eventDate")) : {};
    // console.log({
    //   userRole
    // })
    return (
      <Template current="live" footerVariant="nologo">
        <Grid item xs={12} container className={classes.content}>
          <Box className={classes.fullWidth}>
            <Paper square elevation={0} className={classes.paper}>
              <div className={classes.mainWrapper}>
                <Paper className={classes.livePaper} elevation={3}>
                  <Box align="center">
                    <BlockTitle title={"Live"} className={classes.mainTitle} />
                  </Box>

                  <Choose>
                    <When
                      condition={$$data !== undefined && userRole === undefined}
                    >
                      <Box my={6} align="center">
                        <Typography
                          variant="h5"
                          gutterBottom={true}
                          className={clsx(classes.legend, classes.h6extends)}
                        >
                          Merci de vous connecter pour accéder à ce contenu
                        </Typography>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={(e) =>
                            this.props.history.push(
                              "/login?_pn=" +
                                encodeURIComponent(window.location.pathname)
                            )
                          }
                        >
                          {" "}
                          Connexion
                        </Button>
                      </Box>
                    </When>
                    <When
                      condition={
                        $$data !== undefined &&
                        (userRole === "member" ||
                          userRole === "admin" ||
                          userRole === "staff")
                      }
                    >
                      <If condition={$$card !== undefined}>
                        <If
                          condition={
                            $$card.get("eventState") === "live" ||
                            userRole === "admin" ||
                            userRole === "staff"
                          }
                        >
                          <If
                            condition={
                              $$card.get("eventLinkLive") !== undefined &&
                              $$card.get("eventLinkLive") !== false &&
                              $$card.get("eventLinkLive") !== null &&
                              $$card.get("eventLinkLive") !== ""
                            }
                          >
                            <If
                              condition={
                                $$card.get("eventLinkInstructions") !==
                                  undefined &&
                                $$card.get("eventLinkInstructions") !== false
                              }
                            >
                              <Typography
                                variant={"subtitle1"}
                                align="center"
                                className={classes.instructions}
                                gutterBottom={true}
                              >
                                <Paragrapher
                                  prettyfy={true}
                                  text={$$card.get("eventLinkInstructions")}
                                />
                              </Typography>
                            </If>

                            <Box mt={0} mb={1} px={4} align="center">
                              <Typography variant="caption">
                                <span className={classes.inline}>
                                  {i18n.get("liveInfo")}
                                </span>
                              </Typography>
                            </Box>

                            <BlockRatio ratio={"16_9"}>
                              <iframe
                                title="replay"
                                src={$$card.get("eventLinkLive")}
                                className={"embed"}
                                width="100%"
                                height="100%"
                                frameBorder="0"
                                allow="autoplay; fullscreen"
                                allowFullScreen
                              />
                            </BlockRatio>

                            <Box my={2}>
                              <Typography variant="h5">
                                Posez votre question ici :
                              </Typography>
                            </Box>
                            <LiveMessage
                              $$event={$$card}
                              onMessageSent={this._onMessageSent}
                            />

                            <Orchestrator
                              $$card={$$card}
                              $$data={$$data}
                              eventId={$$card.get("id")}
                              pull={true}
                            />
                          </If>
                          <If
                            condition={
                              $$card.get("eventLinkExternal") !== "" &&
                              $$card.get("eventLinkExternal") !== undefined &&
                              $$card.get("eventLinkExternal") !== null
                            }
                          >
                            <Box my={6} align="center">
                              <If
                                condition={
                                  $$card.get("eventLinkInstructions") !==
                                    undefined &&
                                  $$card.get("eventLinkInstructions") !== ""
                                }
                              >
                                <Typography
                                  variant={"subtitle1"}
                                  className={classes.buttonLegend}
                                  gutterBottom={true}
                                >
                                  <Paragrapher
                                    prettyfy={true}
                                    text={$$card.get("eventLinkInstructions")}
                                  />
                                </Typography>
                              </If>
                              //{" "}
                              <Typography
                                variant={"subtitle1"}
                                gutterBottom={true}
                              >
                                Après avoir cliqué sur le lien ci-dessous,
                                passez votre souris sur l'image de la
                                webconférence à gauche.
                                <br />
                                // Cliquez sur <strong>"+ d'infos"</strong>.
                                <br />
                                // Enfin, cliquez sur le bouton en haut à droite{" "}
                                <strong>"s'inscire"</strong>
                              </Typography>
                              <Button
                                color={"default"}
                                className={classes.big}
                                onClick={this._gotoLiveRoom}
                              >
                                Cliquez pour être redirigé vers la salle de la
                                webconférence
                              </Button>
                            </Box>
                          </If>

                          <If
                            condition={
                              $$card.get("eventLinkLive") === undefined ||
                              $$card.get("eventLinkLive") === false ||
                              $$card.get("eventLinkLive") === null ||
                              $$card.get("eventLinkLive") === "" ||
                              ($$card.get("eventLinkExternal") === "" &&
                                $$card.get("eventLinkExternal") ===
                                  undefined) ||
                              $$card.get("eventLinkExternal") === null
                            }
                          >
                            <Typography variant="h4">
                              Vous devez configurer la vidéo ou le lien externe
                              de cet événement !!!
                            </Typography>
                          </If>
                        </If>
                        <If
                          condition={
                            $$card.get("eventState") === "pending" &&
                            userRole !== "admin" &&
                            userRole !== "staff"
                          }
                        >
                          <Box my={8} align="center">
                            <Typography
                              variant="h5"
                              gutterBottom={true}
                              className={clsx(
                                classes.legend,
                                classes.h6extends
                              )}
                            >
                              {$$card.get("eventTitle")}
                            </Typography>
                            <Typography
                              variant="h6"
                              gutterBottom={true}
                              className={clsx(
                                classes.legend,
                                classes.h6extends
                              )}
                            >
                              {"Votre webconférence débute dans :"}
                            </Typography>
                            <RemainingTime
                              days={timeRemaining.days}
                              hours={timeRemaining.hours}
                              minutes={timeRemaining.minutes}
                            />

                            <If condition={showLiveButton === true}>
                              <Box align="center" py={3}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                    window.location.replace(
                                      window.location.href
                                    );
                                  }}
                                >
                                  Cliquez pour recharger la page et accéder au
                                  live !
                                </Button>
                              </Box>
                            </If>
                            <If condition={showLiveButton !== true}>
                              <Box align="center" py={3}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                    window.location.replace(
                                      window.location.href
                                    );
                                  }}
                                >
                                  Cliquez pour recharger la page
                                </Button>
                              </Box>
                            </If>
                          </Box>
                        </If>

                        <If
                          condition={
                            $$card.get("eventState") === "finished" &&
                            userRole !== "admin" &&
                            userRole !== "staff"
                          }
                        >
                          <Box my={8} align="center">
                            <Typography
                              variant="h5"
                              gutterBottom={true}
                              className={clsx(
                                classes.legend,
                                classes.h6extends
                              )}
                            >
                              Votre événement est terminé !
                            </Typography>
                          </Box>
                        </If>
                      </If>
                      <If condition={$$card === undefined}>
                        <Box my={8} align="center">
                          <Typography
                            variant="h5"
                            gutterBottom={true}
                            className={clsx(classes.legend, classes.h6extends)}
                          >
                            Vous n'êtes pas inscrit(e) à cette webconférence :(
                          </Typography>
                          <Box mt={3}>
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={() => {
                                window.location.replace("/");
                              }}
                            >
                              Cliquez pour retourner à l'accueil
                            </Button>
                          </Box>
                        </Box>
                      </If>
                    </When>
                    <When
                      condition={$$data !== undefined && userRole === "speaker"}
                    >
                      <p>No place for speaker</p>
                    </When>
                    <Otherwise>
                      <div className={"Loading"}>
                        <Spinner style={{ marginTop: 200 }}>
                          Chargement...
                        </Spinner>
                      </div>
                    </Otherwise>
                  </Choose>
                </Paper>
                <LiveHelp style={{ marginBottom: 0 }} />

                <Snackbar
                  open={
                    logMessage !== "" &&
                    logMessage !== undefined &&
                    logMessage !== false
                  }
                  autoHideDuration={3000}
                  onClose={this._handleSnackbarClose}
                >
                  <Alert onClose={this._handleSnackbarClose} severity="success">
                    {logMessage}
                  </Alert>
                </Snackbar>
              </div>
            </Paper>
          </Box>
        </Grid>
      </Template>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataHome(state),
    error: getLoadingError(state),
    isLoggedIn: isLoggedIn(state),
    userRole: getCurrentUserRole(state),
    $$user: getCurrentUser(state),
    $$liveData: getLiveData(state),
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  return {
    onMount: ({ liveId }) => {
      dispatch(
        fetchData({
          key: AF_KEY,
          fetchUrl: config.home,
        })
      );
      dispatch(
        fetchLive({
          liveId,
        })
      );
    },
  };
}
// export default ;
export default withStyles(styles)(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Lives))
);



// WEBPACK FOOTER //
// ./src/components/Lives/LivePlayerOrchestrator.jsx